import React, { useEffect, useState, useContext, createContext } from "react";
import { openCartModal } from "../shared/openCartModal";
import { itemApi } from "../api";
import { cartApi } from "../api";


const dataContext = createContext();
export const useContextElement = () => useContext(dataContext);

export default function Context({ children }) {
    const [cartProducts, setCartProducts] = useState([]);
    const [quickViewItem, setQuickViewItem] = useState(null);
    const [quickAddItem, setQuickAddItem] = useState(1);
    const [totalPrice, setTotalPrice] = useState(0);
    const [cartLoading, setCartLoading] = useState(true);
    const [quickViewLoading, setQuickViewLoading] = useState(false);

    const [orderLoading, setOrderLoading] = useState(false);




    useEffect(() => {
        const subtotal = cartProducts.reduce(
            (acc, product) => acc + product.quantity * product.price,
            0
        );
        setTotalPrice(subtotal);
    }, [cartProducts]);



    // useEffect(() => {
    //     const loadCart = async () => {
    //         try {
    //             const res = await cartApi.getCart();
    //             const cartItems = res.data?.cart?.items || [];
    //
    //             const enrichedItems = await Promise.all(
    //                 cartItems.map(async ({ itemSlug, itemCount, unitPrice, totalPrice, variantGuid }) => {
    //                     try {
    //                         const itemDetail = await itemApi.getItemBySlug(itemSlug);
    //                         const item = itemDetail.data.formattedItem;
    //                         const variant = item.variants.find(v => v.guid === variantGuid);
    //
    //                         if (!variant) return null;
    //
    //                         return {
    //                             id: item._id,
    //                             slug: item.slug,
    //                             title: item.name,
    //                             price: unitPrice,
    //                             quantity: itemCount,
    //                             totalPrice,
    //                             variantGuid: variant.guid,
    //                             size: variant.size,
    //                             isStock: variant.isStock,
    //                             coverImage: item.images?.[0]?.coverImage,
    //                             category: item.category?.name,
    //                         };
    //                     } catch {
    //                         return null;
    //                     }
    //                 })
    //             );
    //
    //             setCartProducts(enrichedItems.filter(Boolean));
    //         } catch (err) {
    //             console.error("Sepet çekilemedi", err);
    //         }
    //     };
    //
    //     loadCart();
    // }, []);
    useEffect(() => {
        console.log("🟢 CONTEXT MOUNTED");
        const loadCart = async () => {
            console.log("🟡 LOADCART STARTED");
            try {
                console.log("📡 FETCH CART");
                const res = await cartApi.getCart();
                console.log("📡 CART RESPONSE", res.data);
                const cartItems = res.data?.cart?.items || [];

                const enrichedItems = await Promise.all(
                    cartItems.map(async ({ itemSlug, itemCount, unitPrice, totalPrice, variantGuid }) => {
                        try {
                            const itemDetail = await itemApi.getItemBySlug(itemSlug);
                            const item = itemDetail.data.formattedItem;
                            const variant = item.variants.find(v => v.guid === variantGuid);
                            if (!variant) return null;

                            return {
                                id: item._id,
                                slug: item.slug,
                                title: item.name,
                                price: unitPrice,
                                quantity: itemCount,
                                totalPrice,
                                variantGuid: variant.guid,
                                size: variant.size,
                                isStock: variant.isStock,
                                coverImage: item.images?.[0]?.coverImage,
                                category: item.category?.name,
                            };
                        } catch {
                            return null;
                        }
                    })
                );

                setCartProducts(enrichedItems.filter(Boolean));
            } catch (err) {
                console.error(" LOADCART ERROR", err);
            } finally {
                console.log("🔴 LOADCART FINISHED");
                setCartLoading(false);
            }
        };

        loadCart();
    }, []);





    const fetchProductBySlug = async (slug) => {
        try {
            const res = await itemApi.getItemBySlug(slug);
            const product = res.data.formattedItem;
            return product;
        } catch (err) {
            console.error("Ürün alınamadı:", err);
            return null;
        }
    };



    const isAddedToCartProducts = (slug, variantGuid) =>
        !!cartProducts.find((item) => item.slug === slug && item.variantGuid === variantGuid);





    const addProductToCart = async (slug, qty = 1, variantGuid, isModal = true) => {
        setCartLoading(true);

        const alreadyAdded = cartProducts.find(
            (item) => item.slug === slug && item.variantGuid === variantGuid
        );

        if (!alreadyAdded) {
            const product = await fetchProductBySlug(slug);
            if (product) {
                const variant = product.variants.find(v => v.guid === variantGuid);
                if (!variant) {
                    console.error("Varyant bulunamadı:", variantGuid);
                    return;
                }

                const unitPrice = product.totalPrice;
                const totalPrice = qty * unitPrice;

                const payload = {
                    itemSlug: slug,
                    itemCount: qty,
                    variantGuid,
                    unitPrice,
                    totalPrice,
                };


                try {
                    await cartApi.addToCart(payload);
                } catch (err) {
                    console.error("Sepete ekleme hatası:", err.response?.data || err.message);
                    return;
                }

                setCartProducts((prev) => [
                    ...prev,
                    {
                        ...product,
                        quantity: qty,
                        variantGuid,
                        size: variant.size,
                        isStock: variant.isStock,
                    },
                ]);
                if (isModal) openCartModal();
            }
        }
        setCartLoading(false);

    };

    const reloadCart = async () => {
        setCartLoading(true);
        try {
            const res = await cartApi.getCart();
            const cartItems = res.data?.cart?.items || [];

            const enrichedItems = await Promise.all(
                cartItems.map(async ({ itemSlug, itemCount, unitPrice, totalPrice, variantGuid }) => {
                    try {
                        const itemDetail = await itemApi.getItemBySlug(itemSlug);
                        const item = itemDetail.data.formattedItem;
                        const variant = item.variants.find(v => v.guid === variantGuid);
                        if (!variant) return null;

                        return {
                            id: item._id,
                            slug: item.slug,
                            title: item.name,
                            price: unitPrice,
                            quantity: itemCount,
                            totalPrice,
                            variantGuid: variant.guid,
                            size: variant.size,
                            isStock: variant.isStock,
                            coverImage: item.images?.[0]?.coverImage || "/default.png",
                            oldPrice: item.oldPrice || null,
                            category: item.category?.name,
                        };
                    } catch (err) {
                        console.warn(`Ürün yüklenemedi: ${itemSlug}`, err);
                        return null;
                    }
                })
            );

            setCartProducts(enrichedItems.filter(Boolean));
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setCartLoading(false);
                });
            });
        } catch (err) {
            console.error("🧨 Cart reload hatası:", err);
            setCartLoading(false);
        }
    };


    const updateQuantity = async (slug, qty, variantGuid) => {
        try {
            await cartApi.updateCartItem(slug, {
                itemCount: qty,
                variantGuid,
            });
            setCartProducts((prev) =>
                prev.map((item) =>
                    item.slug === slug && item.variantGuid === variantGuid
                        ? { ...item, quantity: Number(qty) }
                        : item
                )
            );
        } catch (err) {
            console.error("Miktar güncellenemedi:", err.response?.data || err.message);
        }
    };


    const removeProductFromCart = async (slug, variantGuid) => {
        try {

            await cartApi.removeCartItem({ itemSlug: slug, variantGuid });

            setCartProducts((prev) =>
                prev.filter(item => !(item.slug === slug && item.variantGuid === variantGuid))
            );
        } catch (err) {
            console.error("Ürün sepetten silinemedi:", err.response?.data || err.message);
        }
    };





    const contextElement = {
        cartProducts,
        totalPrice,
        addProductToCart,
        updateQuantity,
        isAddedToCartProducts,
        quickViewItem,
        setQuickViewItem,
        quickAddItem,
        setQuickAddItem,
        setCartProducts,
        removeProductFromCart,
        fetchProductBySlug,
        reloadCart,
        cartLoading,            // ✅ ekle
        setCartLoading,          // ✅ ekle
        quickViewLoading,
        setQuickViewLoading,
        orderLoading,
        setOrderLoading

    };

    window.APP_CART_CONTEXT = contextElement;

    return (
        <dataContext.Provider value={contextElement}>
            {children}
        </dataContext.Provider>
    );
}
